<template>
    <div class="page-container">
      <div class="card-wrapper">

        <div class="pageTitle">
          <h3>Guaranteed Rent Agreement</h3>
        </div>
        
        
        <!-- Top Banner Header Box -->
        <header class="hero-banner">
          <h1 class="banner-title">Secure Stewardship</h1>
          <p class="banner-subtitle">
            Review your automated rental protection terms and activate your guaranteed rent today.
          </p>
        </header>
  
        <!-- Main Document Legal Content Section -->
        <main class="agreement-section">
          <div class="document-header">
            <!-- Document / Agreement Line Icon -->
            <svg viewBox="0 0 24 24" class="svg-doc-icon">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
            <h2 class="document-title">Agreement Details</h2>
          </div>
  
          <!-- Terms Clauses -->
          <div class="clauses-container">
            <article class="clause-item">
              <h3 class="clause-heading">1. Scope of Service</h3>
              <p class="clause-body">
                This Guaranteed Rent Agreement ("Agreement") outlines the terms under which our platform ensures monthly rental payments to the Landlord, regardless of tenant occupancy or payment status. The service is designed to provide financial predictability and minimize the risks associated with property management.
              </p>
            </article>
  
            <article class="clause-item">
              <h3 class="clause-heading">2. Eligibility & Verification</h3>
              <p class="clause-body">
                Properties must meet specific safety and habitability standards as defined by local regulations. By activating this service, you certify that the listed property has valid gas safety certificates, electrical installation condition reports, and is structurally sound.
              </p>
            </article>

            <article class="clause-item">
              <h3 class="clause-heading">3. Tenancy Agreement</h3>
              <p class="clause-body">
               Ensure that all tenancy agreement has been signed by all tenants
              </p>
            </article>
          </div>
  
          <!-- Custom Styled Functional Interactive Checkbox -->
          <label class="consent-checkbox-wrapper">
            <input 
              type="checkbox" 
              v-model="isAgreed" 
              class="hidden-checkbox" 
            />
            <span class="custom-checkbox-box"></span>
            <span class="consent-label-text">
              I have read and agree to the <a href="#" class="inline-link" @click.prevent>Terms &amp; Conditions</a> and the <a href="#" class="inline-link" @click.prevent>Privacy Policy</a> for Guaranteed Rent
            </span>
          </label>
        </main>
  
        <!-- Bottom Info Callout Card -->
        <footer class="why-activate-box">
          <div class="info-icon-container">
            <!-- Outline Circle Information Icon -->
            <svg viewBox="0 0 24 24" class="svg-info-icon">
              <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            </svg>
          </div>
          <div class="info-content-container">
            <h4 class="info-heading">Why activate this?</h4>
            <p class="info-body-text">
              Activating Guaranteed Rent eliminates your exposure to tenant arrears and void periods, ensuring your mortgage and maintenance costs are always covered.
            </p>
          </div>
        </footer>

        <div class="button-holder">
          <button class="btn main" @click="routeTo()" :disabled="!isAgreed">Continue</button>
          <button class="btn cancel" @click="goBack()">Cancel</button>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AgreementDetails',
    data() {
      return {
        isAgreed: false
      };
    },
    methods: {
      routeTo() {
        this.$router.push("rent-list");
      },
      goBack() {
        this.$router.go(-1)
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  // Variables Mapping Layout Design Matrix
  $color-bg-base: #f8faff;
  $color-brand-blue: #0041eb;
  $color-bg-callout: #e8ecfc;
  $color-text-title: #0d121f;
  $color-text-body: #3c4453;
  $color-text-muted: #5e6675;
  $color-white: #ffffff;
  // $color-bg-card: #ffffff;
  $color-brand-dark-blue: #0033EA;


  .pageTitle {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 30px;
      h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 24px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        // color: 
      }
  }
  
  // Global Structural Layout Setup
  .page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: $color-bg-base;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    padding: 24px 16px;
    box-sizing: border-box;
  
    .card-wrapper {
      width: 100%;
      max-width: 480px;
      display: flex;
      flex-direction: column;
      gap: 28px;
      background: #f8faff;
      box-shadow: 
        0 0 0 1px rgba(0, 0, 0, 0.05), 
        0 4px 12px rgba(0, 0, 0, 0.05), 
        0 12px 24px rgba(0, 0, 0, 0.05);
        padding: 15px;
        border-radius: 6px;
    }
  
    // Header Banner UI Block
    .hero-banner {
      background-color: $color-brand-blue;
      border-radius: 20px;
      padding: 28px 24px;
      box-shadow: 0 10px 24px rgba($color-brand-blue, 0.15);
  
      .banner-title {
        font-size: 26px;
        font-weight: 700;
        color: $color-white;
        margin: 0 0 10px 0;
        letter-spacing: -0.3px;
        font-family: Lato;
        text-align: left;
      }
  
      .banner-subtitle {
        font-size: 16.5px;
        line-height: 1.45;
        color: rgba($color-white, 0.85);
        margin: 0;
        font-family: Lato;
        text-align: left;
      }
    }
  
    // Legal Agreement Content Interface
    .agreement-section {
      width: 100%;
      padding: 0 4px;
  
      .document-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 24px;
  
        .svg-doc-icon {
          width: 22px;
          height: 22px;
          fill: $color-brand-blue;
        }
  
        .document-title {
          font-size: 25px;
          font-weight: 700;
          color: $color-text-title;
          margin: 0;
          font-family: Lato;
          text-align: left;
        }
      }
  
      // Text Copy Blocks
      .clauses-container {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-bottom: 28px;
  
        .clause-item {
          .clause-heading {
            font-size: 18px;
            font-weight: 700;
            color: $color-text-title;
            margin: 0 0 10px 0;
            font-family: Lato;
            text-align: left;
          }
  
          .clause-body {
            font-size: 16.5px;
            line-height: 1.55;
            color: $color-text-body;
            margin: 0;
            text-align: justify;
            font-family: Lato;
            // text-align: left;
          }
        }
      }
  
      // Interactive Checkbox Interface Row
      .consent-checkbox-wrapper {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        cursor: pointer;
        user-select: none;
  
        .hidden-checkbox {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
  
          // Visual checkbox updates on focus/active check state toggle
          &:checked + .custom-checkbox-box {
            background-color: $color-brand-blue;
            border-color: $color-brand-blue;
  
            &::after {
              content: '';
              position: absolute;
              left: 6px;
              top: 2px;
              width: 5px;
              height: 10px;
              border: solid $color-white;
              border-width: 0 2px 2px 0;
              transform: rotate(45deg);
            }
          }
        }
  
        .custom-checkbox-box {
          position: relative;
          width: 20px;
          height: 20px;
          min-width: 20px;
          background-color: $color-white;
          border: 1.5px solid #c2c9d6;
          border-radius: 6px;
          box-sizing: border-box;
          transition: all 0.2s ease;
        }
  
        .consent-label-text {
          font-size: 15px;
          line-height: 1.45;
          color: $color-text-body;
          font-weight: 500;
          font-family: Lato;
          text-align: left;
  
          .inline-link {
            color: #002db3;
            text-decoration: none;
            font-weight: 700;
  
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  
    // Bottom Informational Highlight Box
    .why-activate-box {
      background-color: $color-bg-callout;
      border-radius: 16px;
      padding: 20px;
      display: flex;
      gap: 14px;
      align-items: flex-start;
  
      .info-icon-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 2px;
  
        .svg-info-icon {
          width: 22px;
          height: 22px;
          fill: $color-brand-blue;
        }
      }
  
      .info-content-container {
        display: flex;
        flex-direction: column;
        gap: 6px;
  
        .info-heading {
          font-size: 16px;
          font-weight: 700;
          color: #002db3;
          margin: 0;
          font-family: Lato;
          text-align: left;
        }
  
        .info-body-text {
          font-size: 14px;
          line-height: 1.5;
          color: $color-text-muted;
          margin: 0;
          font-weight: 500;
          font-family: Lato;
          text-align: left;
        }
      }
    }
  }
  
  // Media viewports optimization for minor adjustments
  @media (max-width: 400px) {
    .page-container {
      .hero-banner {
        padding: 22px 18px;
        .banner-title { font-size: 21px; }
        .banner-subtitle { font-size: 13.5px; }
      }
      
      .agreement-section {
        .document-header .document-title { font-size: 19px; }
        .clauses-container .clause-item {
          .clause-heading { font-size: 15.5px; }
          .clause-body { font-size: 13.5px; }
        }
        .consent-checkbox-wrapper .consent-label-text { font-size: 13px; }
      }
    }
  }

  .button-holder {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    button {
      width: 100%;
      height: 50px;
      font-family: Lato;
      box-shadow: none;
      outline: 0;
    }
    .main {
      background-color: $color-brand-dark-blue;
      color: $color-white;
      margin-bottom: 15px;
    }
    .cancel {
      background-color: #E6F0FA;
      color: #0033EA;
    }
  }
  </style>
  